import { Inject, Injectable } from "@angular/core";
import { SESSION_SERVICE } from "@comunicare/comunicare-angular-injection-tokens";
import { IVersion } from "@comunicare/comunicare-interfaces";
import { IHelpDataService, IReleaseNote, ISessionService, ISlide } from "@comunicare/comunicare-interfaces-dashboard-services";

/* tslint:disable:no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
@Injectable({
  providedIn: "root",
})
export class HelpDataService implements IHelpDataService {
  constructor(@Inject(SESSION_SERVICE) private sessionService: ISessionService) {}

  transformToNumber(version: string): IVersion {
    throw new Error("Method not implemented.");
  }
  globalHelp: ISlide[];
  patientPageHelp(canDelete: boolean, canDeactivate: boolean, canUpdate: boolean): ISlide[] {
    throw new Error("Method not implemented.");
  }
  patientCareplansHelp: ISlide[];
  patientDrugsHelp: ISlide[];
  patientVitalsignsHelp: ISlide[];
  patientTeleconsultationsHelp: ISlide[];
  patientObservationsHelp: ISlide[];
  patientQRHelp: ISlide[];
  patientAlertHelp: ISlide[];
  teleconsultationsPageHelp: ISlide[];
  patientListPageHelp: ISlide[];
  permissionPageHelp: ISlide[];
  userListPageHelp: ISlide[];
  patientsOrangeAlert: ISlide[];
  patientsRedAlert: ISlide[];
  dailyVideocall: ISlide[];
  lastPatients: ISlide[];
  inactifPatients: ISlide[];
  patientResearch: ISlide[];
  releaseNoteList: IReleaseNote[];
  GroupsListPageHelp: ISlide[];
  QuestionnairesPageHelp: ISlide[];
  CommunicationPageHelp: ISlide[];
  patientCommunicationHelp: ISlide[];
  patientRewardHelp: ISlide[];
  rewardPageHelp: ISlide[];
  patientsListWidget: ISlide[];

  public get knowledgeMediaEditorPageHelp(): ISlide[] {
    const lang = this.sessionService.userLang;
    return [
      {
        title: "globalHelp.knowledgeMediaEditorSummary",
        images: [
          {
            path: "../../../../assets/images/helpCaptures/mediaEditorSummary1" + (lang ? "_" + lang : "_fr") + ".png",
          },
          {
            path: "../../../../assets/images/helpCaptures/mediaEditorSummary2" + (lang ? "_" + lang : "_fr") + ".png",
          },
          {
            path: "../../../../assets/images/helpCaptures/mediaEditorSummary3" + (lang ? "_" + lang : "_fr") + ".png",
          },
        ],
        descriptions: [
          "globalHelp.mediaEditorSummaryP1",
          "globalHelp.mediaEditorSummaryP2",
          "globalHelp.mediaEditorSummaryP3",
          "globalHelp.mediaEditorSummaryP4",
        ],
      },
    ];
  }
  googleAuthHelp: ISlide[];
  drugSchemaPageHelp: ISlide[];
  drugStepwiseSchemaPageHelp: ISlide[];
  patientDocumentHelp: ISlide[];
  billingPageHelp: ISlide[];
}
